<template>
    <div class="printer">
        <div class="printer-banner">
            <div class="main_content">
                <div class="printer-banner-title">快麦云标签打印机</div>
                <div class="printer-banner-text">免下载驱动 远程打印 批量传输</div>
                <div class="printer-banner-btn" @click="openNew('https://cloudprint.kuaimai.com/#/productCenter/WiFi/E41G')">了解更多</div>
            </div>
        </div>
        <div class="printer-content">
            <div class="main_content">
                <div class="printer-header">
                    <div class="menu-list">
                        <div
                            class="menu-item"
                            v-for="menu in menuList" :key="menu.path"
                            :class="{active: menu.path === selectedPath}"
                            @click="routeTo(menu)"
                        >
                            {{ menu.name }}
                        </div>
                    </div>
                    <div class="printer-header-search" v-show="false">
                        <input class="search-input" type="text" placeholder="请输入打印机型号" v-model="printerName"/>
                        <div class="search-input-btn" @click="search">查询</div>
                    </div>
                </div>
                <div v-for="printer in printerList" :key="printer.type">
                    <div class="printer-type">{{ printer.type }}</div>
                    <div class="printer-list">
                        <div class="printer-item" v-for="item in printer.list" :key="item.name" @click="openDetail(item)">
                            <div class="printer-img-box">
                                <img class="printer-img" :src="item.img" alt="printer">
                            </div>
                            <div class="printer-title">{{ item.name }}</div>
                            <div class="printer-text">{{ item.text }}</div>
                            <div class="printer-subtext">{{ item.subtext }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ZhiNeng",
    data() {
        return {
            selectedPath: '/printer/ZhiNeng',
            menuList: [
                {
                    path: "/printer/MianDan",
                    name: "面单打印机",
                },
                {
                    path: "/printer/BiaoQian",
                    name: "标签打印机",
                },
                {
                    path: "/printer/PiaoJu",
                    name: "票据打印机",
                },
                {
                    path: "/printer/CloudPrinter",
                    name: "云打印机",
                },
                {
                    path: "/printer/ZhiNeng",
                    name: "智能设备",
                },
            ],
            printerName: '',
            allPrinterList: [
                {
                    type: '智能设备',
                    list: [
                        {
                            img: require('@/views/printer/images/D30.png'),
                            name: "D30",
                            text: "电商物流智能PDA",
                            subtext: "扫码快，强续航",
                            path: '/printCenter/ZhiNeng/D30'
                        },
                        {
                            img: require('@/views/printer/images/D30se.png'),
                            name: "D30SE",
                            text: "电商物流智能PDA",
                            subtext: "库存盘点必备",
                            path: '/printCenter/ZhiNeng/D30SE'
                        },
                    ]
                },
            ],
            printerList: []
        };
    },
    mounted() {
        this.printerList = this.allPrinterList
    },
    methods: {
        routeTo(menu) {
            if (menu.isLink) {
                window.open(menu.path);
                return;
            }
            let route = menu.path;
            if (!route || route === this.selectedPath) {
                return;
            }
            this.$router.push(route);
        },
        search() {
            let allPrinterList = JSON.parse(JSON.stringify(this.allPrinterList));

            // 1. 如果搜索关键词为空或只包含空格，直接返回原始的完整列表
            if (!this.printerName || !this.printerName.trim()) {
                this.printerList = allPrinterList;
                return;
            }

            // 2. 将搜索关键词转为小写，以便进行不区分大小写的比较
            const searchTerm = this.printerName.toLowerCase();
            this.printerList = allPrinterList.reduce((result, category) => {
                // 4. 对每个分类下的 list 数组进行过滤
                const filteredList = category.list.filter(printer =>
                    // 将每个打印机的 name 也转为小写进行比较
                    printer.name.toLowerCase().includes(searchTerm)
                );

                result.push({
                    ...category,
                    list: filteredList
                });

                // 返回累积的结果，用于下一次迭代
                return result;
            }, [])
        },
        openDetail(item) {
            if (item.url) {
                this.openNew(item.url)
            } else if (item.path) {
                this.$router.push(item.path)
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../printer.scss";

.printer-banner {
    background: url("../MianDan/images/top-bg.jpg") center / 1920rem 500rem no-repeat;
}
</style>
